import { observable } from 'mobx';
import { autobind } from 'core-decorators';
import useMount from '@src/utils/hooks/use-mount';
import useModal from '@src/utils/hooks/use-modal';
import ImageModal from '@src/business-components/image-modal';
import ImageModalStore from '@src/business-components/image-modal/store';
import $$tracker from '@src/tracker';
class AudioListStore {
  // 视频列表
  @observable imageList = [];

  imageModalStore = new ImageModalStore();
  imageModal = null;

  constructor(props = {}) {
    Object.assign(this, props);
  }

  @autobind
  viewImage(index) {
    this.imageModalStore.imagesList = this.imageList.map(i => i.cover);
    this.imageModalStore.currentIndex = index;
    this.imageModalStore.modalState = true;
    $$tracker.clickStzxPicture(this.imageList[index]?.title);
    this.imageModal.open();
  }

  use() {
    this.imageModal = useModal(ImageModal, {
      store: this.imageModalStore
    });

    useMount(() => { });
  }
}

export default AudioListStore;
